export const shipperAmounts = [1, 2, 3, 4, 5];
export const priceAmounts = [5, 10, 15, 20, 25, 30, 35, 40, 45, 50];
